export default "__VITE_PUBLIC_ASSET__f607c2e4__"